export default __webpack_public_path__ + "b45d630884cd5036b18ee5b253ae6472.png";